import React, { Component } from 'react';
import Social from '../empresa/social/';
import { empresa } from '../utilitarios/parametros';
import './footer.css';

export default class Footer extends Component {

    render() {
        return (
            <div className="Footer">
                <div className="FooterContent">

                    {
                        this.props.section != empresa &&
                        <div className="socialFooter">
                            <Social />
                        </div>
                    }
                    <p className="dev">
                        © {new Date().getFullYear()} ELÉCTRICA CAPORALE |
                        Desarrollado por
                        <a href="mailto:brianbentancourt9@gmail.com?Subject=Hola" target="_top"> Brian Bentancourt</a>
                    </p>
                </div>
            </div>
        )
    }

}